import type { MailboxInfo } from 'owa-client-types';
import { action } from 'satcheljs';

export interface OnAccountSwitchedActionMessage {
    oldMailBox: MailboxInfo;
    currentMailBox: MailboxInfo;
}

/**
 * Action invoked when the user switches accounts
 */
const defaultExport: (
    oldMailBox: MailboxInfo,
    currentMailBox: MailboxInfo
) => OnAccountSwitchedActionMessage = action(
    'onAccountSwitched',
    (oldMailBox: MailboxInfo, currentMailBox: MailboxInfo): OnAccountSwitchedActionMessage => ({
        oldMailBox,
        currentMailBox,
    })
);
export default defaultExport;
